import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import axios from 'axios';
import { loader, updateCustomerDetails, updateSearchCustomerDetails } from '../Store/actions/customerInfoActions';
import getAuthHeaders from '../helpers/apiHelpers';

const useUserPersisted = (CIP_DOMAIN: string, currentContactId: string, customerSearchInput: string, callBackEvent: any, origin: string) => {
  const dispatch = useDispatch();

  useEffect(() => {
    const source = axios.CancelToken.source();

    const loadCustomer = async () => {
      try {
        dispatch(loader(true));
        const savedHistorySession = sessionStorage.getItem('searchedResultLDAP');
        const savedHistory = savedHistorySession ? JSON.parse(savedHistorySession) : {}
        const response: any = await axios.post(
          `${CIP_DOMAIN}/api/customer/v1/load`,
          {
            conversationId: currentContactId,
            linkedCustomer: {},
            customerSearchInput,
            origin
          },
          {
            headers: getAuthHeaders(),
            cancelToken: source.token,
          }
        );

        if (response?.data?.success && response?.data?.data?.customerDetails) {
          const customerData = response.data.data.customerDetails?.linkedCustomer;
          dispatch(updateCustomerDetails(response.data.data.customerDetails));
          let searchedCustomer = response.data.data.customerDetails
          if (savedHistory[currentContactId]) {
            let ldap = savedHistory[currentContactId]
            if (ldap) {
              const response: any = await axios.get(`${CIP_DOMAIN}/api/customer/v1/search`, {
                params: {
                  input: ldap,
                  conversationId: currentContactId,
                  autolink: false,
                  getSingleMatch: true
                },
                headers: getAuthHeaders(),
              });
              if (response.data?.success && response.data?.data?.customerDetails?.length > 0) {
                if (response.data?.data?.customerDetails?.length > 0) {
                  searchedCustomer = { linkedCustomer: response.data.data.customerDetails[0] };
                }
              }
            }
          }
          dispatch(updateSearchCustomerDetails(searchedCustomer));
          const eventData = {
            "firstName": customerData.firstName || '',
            "lastName": customerData.lastName || '',
            "email": customerData.email || '',
            "phone": customerData.originalPhone || '',
            "rengaId": customerData.ldap || '',
            "username": customerData.ldap || '',
            "contactId": currentContactId || '',
            "isDirectorOrAbove": customerData.isDirectorOrAbove || 'false'
          }
          callBackEvent('UPDATE_CUSTOMER_INFO', eventData)
        }
      } catch (err) {
        console.error('Error loading customer:', err);
      } finally {
        dispatch(loader(false));
      }
    };

    loadCustomer();

    return () => {
      source.cancel();
    };
  }, [CIP_DOMAIN, currentContactId, dispatch, origin]);
};

export default useUserPersisted;
